import { Component, OnInit } from '@angular/core';
import { ResolverService } from 'src/app/___LOGIC/__common/resolver.service';

@Component({
  selector: 'app-bach-legal-clients',
  templateUrl: './bach-legal-clients.component.html',
  styleUrls: ['./bach-legal-clients.component.css']
})
export class BachLegalClientsComponent implements OnInit {

  constructor(private resolver: ResolverService) {
      this.resolver.getBackendDataForQueryId('getBachLegalContracts',true,null);
    }
  
    ngOnInit(): void {
    }
  
    getBachLegalClients(){
      return this.resolver.resolveList('getBachLegalContracts');
    }
  

}
